<template>
    <div class="content-wrap">
        <div class="title">
            <Icon type="ios-key" class="icon-style" />
            <title-text :inline="true" :onlyText="false">{{
                curItemObj ? curItemObj.dataName : '-'
            }}</title-text>
        </div>
        <div class="icon-operate" v-if="isEdit">
            <div
                class="icon-font-wrap"
                :class="{ checked: checkAll }"
                @click="checkAllData"
            >
                <Icon type="ios-browsers" class="icon-comm" />
                <div class="checked-all font-style">全选</div>
            </div>
            <div
                class="icon-font-wrap"
                :class="{ checked: checkClear }"
                @click="clearAllData"
            >
                <Icon type="ios-trash" class="icon-comm" />
                <div class="checked-clear font-style">清空</div>
            </div>
        </div>
        <div class="encTree scrollbar" :class="{detailH:!isEdit,editH:isEdit}" v-if="treeData.length !== 0">
            <enc-tree
                ref="encTree"
                :data-array="treeData"
                :render="renderContent"
                :show-checkbox="isEdit"
                value-key="id"
                @on-check-change="handleCheckChange"
            ></enc-tree>
        </div>
        <div v-else class="img-wrap">
            <div>
                <img :src="require('./../../../../assets/noData.png')" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import EncTree from '../../../../components/EncTree.vue'
import utils from '../../../../common/utils'

export default {
    name: 'systemMenu',
    components: { EncTree },
    props: ['initDataObj', 'selectData', 'isEdit', 'curItemObj'],
    data() {
        return {
            treeData: [],
            checkAll: false,
            checkClear: false,
            childrenKey: 'children'// children
        }
    },
    watch: {
        // isEdit, selectData
        listenChangeData: {
            handler(val) {
                if (val.isEdit === false) {
                    // this.treeData = []
                    this.treeData = utils.arrayToTree(val.selectData && val.selectData.systemMenu ? JSON.parse(JSON.stringify(val.selectData.systemMenu)) : [], {
                        key: 'id',
                        parentKey: 'parentId'
                    })
                    // 展开两层
                    utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                        if (node.parentId === 0) {
                            node.expand = true
                        }
                    })
                }
            },
            immediate: true
        },
        // isEdit, initDataObj
        listenChange: {
            handler(val) {
                if (val.isEdit === true && val.initDataObj && val.initDataObj[this.curItemObj.dataValue] && val.initDataObj[this.curItemObj.dataValue].length !== 0) {
                    console.log('===============')
                    // const initDataCur = utils.deepClone(this.initDataObj[this.curItemObj.dataValue])
                    const initDataCur = this.initDataObj[this.curItemObj.dataValue]
                    // utils.treeForeach(initDataCur, this.childrenKey, (node) => {
                    //     if (node.node) {
                    //         node.children = node.node
                    //     }
                    //     node.selected = false
                    //     this.$set(node, 'selected', false)
                    //     this.$set(node, 'checked', false)
                    // })
                    const idsObj = [];
                    if (this.selectData.systemMenu && this.selectData.systemMenu.length) {
                        this.selectData.systemMenu.forEach((item) => {
                            if (item.isChild === 1) {
                                idsObj[item.id] = item.id
                            }
                        });
                    }

                    this.treeData = initDataCur;
                    this.$nextTick(() => {
                        this.$refs.encTree.setCheckedNodes(idsObj)
                    })

                    // this.initDataObj[this.curItemObj.dataValue] = initDataCur
                }
            },
            immediate: true
        }
    },
    computed: {
        listenChangeData() {
            const { isEdit } = this
            const { selectData } = this
            return { isEdit, selectData }
        },
        listenChange() {
            const { isEdit } = this
            const { initDataObj } = this
            return { isEdit, initDataObj }
        }
    },
    created() {},
    mounted() {},
    methods: {
        renderContent(h, { data }) {
            return h('span', {}, [h('span', data.name)])
        },
        handleCheckChange() {
            let treeLength = 0
            utils.treeForeach(this.treeData, this.childrenKey, (node) => {
                if (node.id) {
                    treeLength += 1
                }
            })
            console.log('11111')

            this.initDataObj[this.curItemObj.dataValue] = this.treeData
            const checkLen = this.$refs.encTree.getCheckedNodes().length
            if (treeLength === checkLen) {
                this.checkAll = true
                this.checkClear = false
            } else {
                this.checkAll = false
                this.checkClear = false
            }
        },
        checkAllData() {
            this.checkAll = true
            this.checkClear = false
            this.$refs.encTree.setSelectedNodesAll()
            console.log('11111')

            this.initDataObj[this.curItemObj.dataValue] = this.treeData
        },
        clearAllData() {
            this.checkAll = false
            this.checkClear = true
            this.$refs.encTree.setSelectedNodesClear()
        }
    }
}
</script>

<style lang='less' scoped>
.content-wrap {
    height: 100%;
    .title {
        height: 29px;
        font-size: 19px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: var(--base-font-color);
        line-height: 29px;
        .icon-style {
            margin-right: 5px;
        }
    }
    .icon-operate {
        display: flex;
        padding-top: 19px;
        padding-bottom: 9px;
        padding-left: 30px;
        .icon-font-wrap {
            display: flex;
            align-items: center;
            margin-right: 27px;
            .font-style {
                cursor: pointer;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                line-height: 22px;
            }
            .icon-comm {
                font-size: 16px;
                padding-right: 5px;
            }
        }
        .checked {
            color: #0fb2ab;
        }
    }
    .detailH{
            height: calc(100vh - 300px);
    }
    .editH{
        height: calc(100vh - 350px);
    }
    .img-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 85%;
    }
}
</style>
